<template>
  <div class="business-manager-wrap">
    <img src="@/assets/images/kefu.png" class="kefu" @click="toggleDialog" />
    <div :class="{ dialog: true, show: dialogShow, 'ticket-only': !nickName }">
      <div class="close" @click="toggleDialog">
        <p></p>
      </div>
      <div v-if="nickName" class="avatar">
        <b-img
          v-bind="mainProps"
          alt="Circle image"
          v-if="avatar"
          :src="avatar"
        ></b-img>
        <img
          v-else
          src="@/assets/images/default_manager.png"
          class="defalut-manager"
        />

        <div class="right">
          <h3>{{ nickName }}</h3>
          <p>Account Manager</p>
        </div>
      </div>
      <div v-if="nickName" class="detail">
        <p v-if="businessDetail.phone">
          <label><img src="@/assets/images/phone.png" /></label>
          <span>{{ businessDetail.phone }}</span>
        </p>
        <p v-if="businessDetail.email">
          <label><img src="@/assets/images/email.png" /></label>
          <span>{{ businessDetail.email }}</span>
        </p>
        <p v-if="businessDetail.whatsapp">
          <label><img src="@/assets/images/whats.png" /></label>
          <span>{{ businessDetail.whatsapp }}</span>
        </p>
        <p v-if="businessDetail.wechat">
          <label><img src="@/assets/images/wechat.png" /></label>
          <span>{{ businessDetail.wechat }}</span>
        </p>
        <p v-if="businessDetail.skype">
          <label><img src="@/assets/images/skype.png" /></label>
          <span>{{ businessDetail.skype }}</span>
        </p>

        <!-- <div class="item" v-for="(item, index) in businessDetail" :key="index">
          <label v-if="item[0] == 'phone' && item[1]"
            ><img src="@/assets/images/phone.png"
          /></label>
          <label v-else-if="item[0] == 'email' && item[1]"
            ><img src="@/assets/images/email.png"
          /></label>
          <label v-else-if="item[0] == 'whatsapp' && item[1]"
            ><img src="@/assets/images/whats.png"
          /></label>
          <label v-else-if="item[0] == 'wechat' && item[1]"
            ><img src="@/assets/images/wechat.png"
          /></label>
          <label v-else-if="item[0] == 'skype' && item[1]"
            ><img src="@/assets/images/skype.png"
          /></label>
          <span v-if="item[0] != 'nick_name'">{{ item[1] }}</span>
        </div> -->
      </div>
      <div class="ticket-action">
        <p class="ticket-intro"><strong>{{ $t('ticket.intro').split('\n')[0] }}</strong><br>{{ $t('ticket.intro').split('\n').slice(1).join('\n') }}</p>
        <el-button type="primary" @click="$refs.ticketForm.open()">{{ $t('ticket.title') }}</el-button>
      </div>
    </div>
    <ticket-form ref="ticketForm" />
  </div>
</template>
<script>
import TicketForm from './TicketForm.vue'

export default {
  components: { TicketForm },
  data () {
    return {
      dialogShow: false,
      mainProps: {
        blank: false,
        width: 65,
        height: 65,
        class: 'm1',
      },
      avatar: '',
      loginName: '',
      nickName: '',
      realName: '',
      businessDetail: {},
    }
  },
  methods: {
    toggleDialog () {
      this.dialogShow = !this.dialogShow
    },
  },
  mounted () {
    try {
      const businessManager = JSON.parse(localStorage.getItem('businessManager'))
      const manager = businessManager && businessManager.accountManager
      if (!manager || !manager.detail) return
      const detail = typeof manager.detail === 'string' ? JSON.parse(manager.detail) : manager.detail
      if (!detail || typeof detail.nick_name !== 'string' || !detail.nick_name.trim()) return
      this.businessDetail = detail
      this.nickName = detail.nick_name.trim()
      this.avatar = typeof manager.avatar === 'string' ? manager.avatar : ''
    } catch (error) {
      // Missing or malformed manager data must not block the support ticket entry.
    }
  },
}
</script>
<style scoped lang="scss">
.ticket-action {
  padding: 0 20px 20px;
  .ticket-intro {
    white-space: pre-line;
    margin: 0 0 12px;
    color: #666;
    font-size: 13px;
    line-height: 1.5;
    strong {
      color: #161616;
      font-family: "Arial Black", "PingFang SC", "Microsoft YaHei", sans-serif;
      font-weight: 900;
    }
  }
  .el-button { width: 100%; }
}
.defalut-manager {
  width: 65px;
  height: 65px;
}
.business-manager-wrap {
  position: relative;
  .kefu {
    cursor: pointer;
  }
  .avatar {
    display: flex;
    margin-top: 30px;
    margin-left: 20px;
    img {
      border: 1px solid #d7d7d7;
      object-fit: scale-down;
    }
    .right {
      margin-left: 40px;
      h3 {
        font-size: 18px;
        margin-top: 7px;
        margin-bottom: 10px;
      }
    }
  }
  .dialog {
    position: absolute;
    bottom: 50px;
    right: 70px;
    width: 280px;
    min-height: 300px;
    &.ticket-only {
      min-height: 0;
      padding-top: 40px;
    }
    background: #fff;
    font-size: 14px;
    display: block;
    box-shadow: 1px 2px 5px #999;
    border-radius: 5px;
    opacity: 0;
    transform: scale(0.1);
    transform-origin: right bottom;
    &.show {
      transition: all 0.4s ease-in-out;
      opacity: 1;
      transform: scale(1);
    }
    .close {
      position: absolute;
      width: 22px;
      height: 20px;
      right: 17px;
      top: 9px;
      cursor: pointer;
      p {
        width: 22px;
        height: 3px;
        background: #000;
        border-radius: 20px;
        margin-top: 8px;
      }
    }
    .detail {
      padding: 20px;
      .item {
        display: flex;
      }
      label {
        text-align: left;
        margin-right: 10px;
        // &::after {
        //   content: ":";
        // }
      }
      span {
        word-break: break-all;
      }
    }
  }
}
</style>
